import { basketballConfig } from "config/sport/basketball";
import { defaultsConfig } from "config/sport/defaults";
import { handballConfig } from "config/sport/handball";
import { hockeyConfig } from "config/sport/hockey";
import { isEmpty } from "lodash";
import { useParams } from "react-router-dom";
import type { SportConfiguration } from "types/sportConfiguration";
import { basketballUiConfig } from "../config/sport/basketballUi.ts";
import { defaultsUiConfig } from "../config/sport/defaultsUi.ts";
import { handballUiConfig } from "../config/sport/handballUi.ts";
import { hockeyUiConfig } from "../config/sport/hockeyUi.ts";
import type { SportUiConfiguration } from "../types/sportUiConfiguration.ts";

const config: { [sport: string]: SportConfiguration } = {
  basketball: basketballConfig,
  handball: handballConfig,
  hockey: hockeyConfig,
  defaults: defaultsConfig,
};

const uiConfig: { [sport: string]: SportUiConfiguration } = {
  basketball: basketballUiConfig,
  handball: handballUiConfig,
  hockey: hockeyUiConfig,
  defaults: defaultsUiConfig,
};

export const useSportConfiguration = () => {
  const { sport: sportFromParams } = useParams();
  const sport = sportFromParams?.toLowerCase() ?? "";

  const sportConfig = config[sport];
  const sportUiConfig = uiConfig[sport];

  return {
    configuration: isEmpty(sportConfig) ? config.defaults : sportConfig,
    uiConfiguration: isEmpty(sportUiConfig) ? uiConfig.defaults : sportUiConfig,
  };
};
